const typeNamespace = 'CONTENT_';

export const AVATAR_LIST = `${typeNamespace}AVATAR_LIST`;